import * as React from 'react';

import { StoryBanner } from '@/components/story/story-banner';
import { StoryBeats } from '@/components/story/story-beats';
import { StoryClosingCta } from '@/components/story/story-closing-cta';
import { storyMeta } from '@/content/my-story';

/**
 * Dignity-first first-person journey page (spec §5).
 * Magazine-style reading experience; excludes all §5.1 sensitive material.
 */
export function MyStoryPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = storyMeta.documentTitle;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="flex flex-col">
      <StoryBanner />

      {/* Gentle fade into the reading body — no heavy scrim */}
      <div
        aria-hidden
        className="pointer-events-none h-16 bg-gradient-to-b from-transparent to-background/40"
      />

      <StoryBeats />

      <StoryClosingCta />
    </article>
  );
}
